import React from "react";
import {Provider} from 'react-redux';
import store from './store';
import {createMuiTheme, MuiThemeProvider,} from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";


import PhoneContainer from './components/phone-container';
import ErrorBoundary from "./components/error-boundary";

const theme = createMuiTheme({
	typography: {
		useNextVariants: true,
	},
	palette: {
		primary: {
			light: "#0087FF",
			main: "#0087FF",
			dark: "#005ebc",
			contrastText: "#000000"
		},
		secondary: {
			light: "#fffe50",
			main: "#ffcb00",
			dark: "#c79b00",
			contrastText: "#000000"
		},
	}
});


function App() {
	return (
		<Provider store={store}>
			<MuiThemeProvider theme={theme}>
				<CssBaseline />
				<ErrorBoundary>
					<PhoneContainer/>
				</ErrorBoundary>
			</MuiThemeProvider>
		</Provider>
	);
}

export default App;
